var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30589 0.940645L4.99956 5.28786L0.69322 0.940645C0.616281 0.862821 0.512995 0.819252 0.405442 0.819252C0.297889 0.819252 0.194603 0.862821 0.117664 0.940645C0.0804127 0.978441 0.0508082 1.02357 0.0306142 1.07336C0.0104067 1.12316 0 1.17663 0 1.23064C0 1.28465 0.0104067 1.33812 0.0306142 1.38792C0.0508082 1.43772 0.0804127 1.48283 0.117664 1.52063L4.69885 6.14624C4.77931 6.22745 4.88721 6.2729 4.99956 6.2729C5.1119 6.2729 5.21981 6.22745 5.30026 6.14624L9.88145 1.52152C9.91897 1.4837 9.94879 1.43847 9.96914 1.3885C9.98951 1.33855 10 1.28487 10 1.23064C10 1.17642 9.98951 1.12274 9.96914 1.07277C9.94879 1.02282 9.91897 0.977577 9.88145 0.939752C9.80451 0.861928 9.70122 0.818359 9.59367 0.818359C9.48612 0.818359 9.38283 0.861928 9.30589 0.939752V0.940645Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow2);
export default __webpack_public_path__ + "static/media/down-arrow 2.1e02df15d2bbd874b31893c7c31355bd.svg";
export { ForwardRef as ReactComponent };